import React from 'react'
import { ReactComponent as ChatMessageIcon } from 'assets/svgs/chat-message-icon.svg'
import { ReactComponent as MessageEmptyIcon } from 'assets/svgs/message-empty.svg'

interface ChatEmptyStateProps {
  onStartNewChat: () => void
}

const ChatEmptyState: React.FC<ChatEmptyStateProps> = ({ onStartNewChat }) => {
  return (
    <div className="flex flex-col items-center justify-center bg-app-white-100">
      <div className="max-w-md text-center">
        {/* Chat Icon */}
        <div className="mb-6 flex justify-center">
          <MessageEmptyIcon className="w-[124px] h-[124px]" />
        </div>

        {/* Welcome Message */}
        <h2 className="text-md text-app-black-100 mb-2">
          Start a conversation and connect with your team!
        </h2>
        {/* Call to Action Button */}
        <button
          onClick={onStartNewChat}
          className="inline-flex items-center gap-2 bg-app-primary-60 text-app-white-100 px-6 py-3 rounded-lg font-medium hover:bg-app-primary-70 transition-colors duration-150"
        >
          <ChatMessageIcon className="w-5 h-5" />
          Start a New Chat
        </button>
      </div>
    </div>
  )
}

export default ChatEmptyState
